import {SHOW_LOADER, HIDE_LOADER, HIDE_LINEAR_LOADER, SHOW_LINEAR_LOADER} from './AlertActionTypes';

interface IAlert {
    loading: boolean
    linearLoading: boolean
}

const initialState: IAlert = {
    loading: false,
    linearLoading: false
}

const alertsReducer = (state: any = initialState, action: any): IAlert => {
    switch (action.type) {
        case SHOW_LOADER:
            return { ...state, loading:true };
            case HIDE_LINEAR_LOADER:
            return { ...state, linearLoading:false };
            case SHOW_LINEAR_LOADER:
            return { ...state, linearLoading:true };
            case HIDE_LOADER:
                return { ...state, loading:false };
        default:
            return state;
    }
}

export default alertsReducer